import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  formContainer: {
    width: "100%",
    padding: "16px",
  },

  experimentDetailsFormColStyle: { flex: 1 },

  experimentDetailsLabelContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  experimentDetailsTextField: {
    "& .ms-TextField-fieldGroup": {
      border: `1px solid ${theme.palette.neutralTertiary}`,
    },
  },
  experimentDetailsTagPickerDropdown: {
    border: `1px solid ${theme.palette.neutralTertiary} !important`,
  },
  experimentDetailsTagPickerDropdownOption: {
    "& .fui-TagPickerOption": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    "& .fui-TagPickerOption__secondaryContent": {
      color: theme.palette.neutralSecondary,
      paddingLeft: 20,
    },
  },
  experimentDetailsTagPickerDropdownDisabled: {
    backgroundColor: theme.palette.neutralLighterAlt + " !important",
  },
  experimentDetailsTagItemsTextDisabled: {
    color: theme.palette.neutralTertiary + " !important",
  },
  experimentDetailsTagPickedFieldEnabled: {
    "& .ms-BasePicker-text": {
      border: `1px solid ${theme.palette.neutralTertiary}`,
      maxHeight: "200px",
      overflowY: "auto",
    },
  },
  experimentDetailsTagPickedFieldDisabled: {
    "& .ms-BasePicker-text": {
      maxHeight: "200px",
      overflowY: "auto",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: theme.palette.neutralLighter,
      opacity: 0.55,
      pointerEvents: "none",
    },
  },
  experimentDetailsTagPickerStickyInput: {
    "& .ms-BasePicker-input": {
      position: "sticky",
      bottom: 0,
      zIndex: 1,
      backgroundColor: theme.palette.white,
    },
  },
  extensionPrefix: {
    height: "100%",
  },
  extensionPrefixToggleLabel: {
    width: "130px",
  },

  experimentDetailsFormSectionError: {
    color: theme.palette.redDark,
  },
  experimentDetailsFormSectionErrorListItem: {
    color: theme.palette.redDark,
  },

  experimentDetailsFormRow: {},

  experimentDetailsFormTabLabelIconError: {
    color: theme.palette.redDark,
    paddingRight: 4,
  },
  experimentDetailsFormTabLabelIconChanged: {
    color: theme.palette.themeSecondary,
    paddingLeft: 2,
    fontSize: 8,
  },
  experimentDetailsFormTabLabelIcon: {
    color: theme.palette.redDark,
  },
  experimentDetailsFormTabLabelContainer: {
    alignItems: "center",
  },
  experimentDetailsFormTabLabelError: {
    color: theme.palette.redDark,
  },
  experimentDetailsFormTabLabelSelected: {
    fontWeight: 500,
  },
  experimentDetailsFormTabLabel: {
    fontWeight: 400,
  },

  experimentDetailsLabel: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: 0,
  },
  experimentDetailsDescription: {
    display: "flex",
    justifyContent: "flex-start",
    color: theme.palette.neutralSecondary,
    paddingBottom: 2,
    textAlign: "left",
  },
  experimentDetailsInferTypeDescription: {
    backgroundColor: theme.palette.neutralLighter,
    borderRadius: 4,
    width: "90%",
    padding: "4px 8px",
  },

  experimentDetailsLabelAsterisk: {
    color: theme.palette.redDark,
    fontWeight: 700,
  },

  experimentDetailsTooltip: {
    color: theme.palette.themePrimary,
    marginLeft: 4,
    cursor: "pointer",
  },
  experimentDetailsError: {
    color: theme.palette.redDark,
    fontSize: "12px",
    textAlign: "left",
  },

  keyValueFieldRowStart: {
    alignItems: "flex-start",
    width: "100%",
  },
  keyValueFieldRow: {
    alignItems: "flex-end",
    width: "100%",
  },
  keyValueFieldRowInput: {
    width: "100%",
  },
  keyValueFieldInsertButton: {
    marginTop: 27,
    borderRadius: 20,
  },
  baseDropdown: {
    "& .ms-Dropdown-title": {
      display: "flex",
    },
  },

  accordionHeader: {
    "& button": {
      color: theme.palette.neutralPrimary,
      display: "flex",
      fontSize: "15px",
      gap: 5,
      borderBottom: `1px solid ${theme.palette.neutralLight}`,
    },
  },

  accordionPanel: {
    padding: "5px 35px 0 35px",
  },
});

const stackTokens = { childrenGap: 16 };

export { styles, stackTokens };
